import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

import products from './products';
import sportid from './sportid';

export default new Vuex.Store({
    state: {
        activityTypes: {
            1: 'Schaatsles',
            2: 'Vrij schaatsen',
            3: 'Evenement',
        },
        targetAudience: {
            0: "Iedereen", 
            1: "Kinderen met een beperking"
        },
        ageGroups: ["Tot en met 8 jaar", "Tot en met 10 jaar", "Tot en met 12 jaar"],
    },
    mutations: {

    },
    actions: {

    },
    getters: {

    },
    modules: {
        products,
        sportid,
    }
})
